import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const VENDORS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('VENDORS');
export const VENDORS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	VENDORS_CRUD_ACTION_CONSTANTS
);
